<template>
  <v-dialog v-model="dialog" width="80vw">
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <slot />
      </div>
    </template>
    <v-card class="video-dialog">
      <v-icon class="ml-auto close-button" @click="dialog = false">
        mdi-close
      </v-icon>
      <div class="video-container" v-html="video.html" />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'VideoDialog',
  props: {
    video: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dialog: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-card {
    position: relative;
    height: 80vh;
    width: 80vw;
    padding: 40px;
  }

  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .video-container {
    height: 100%;
    width: 100%;
  }
</style>
